import { useId } from "react";
import type { ButtonProps } from "@/components/ui/button";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface RestrictedActionButtonProps extends ButtonProps {
  disabledReason?: string;
}

export function RestrictedActionButton({
  disabledReason,
  children,
  ...props
}: RestrictedActionButtonProps) {
  const descriptionId = useId();

  if (!disabledReason) return <Button {...props}>{children}</Button>;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          {...props}
          disabled={false}
          aria-disabled="true"
          aria-describedby={descriptionId}
          className={cn("cursor-not-allowed opacity-50", props.className)}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
        >
          {children}
        </Button>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        <p>{disabledReason}</p>
      </TooltipContent>
      <span id={descriptionId} className="sr-only">
        {disabledReason}
      </span>
    </Tooltip>
  );
}
